import type { UserProfileDto } from '@today/types'
import { OfferContactSettingsView } from '@today/ui-domain'
import { useTranslation } from 'react-i18next'
import { useOfferContactForm } from '@/hooks/useOfferContactForm'
import { SETTINGS_NAMESPACE } from '@/i18n'

/** The Settings "Contact on offers" section (TO-197 REQ-006 / REQ-010). */
export function OfferContactSettings({ profile }: { profile: UserProfileDto | undefined }) {
	const { t } = useTranslation(SETTINGS_NAMESPACE)
	const form = useOfferContactForm(profile)
	return (
		<OfferContactSettingsView
			enabled={form.draft.enabled}
			onEnabledChange={form.setEnabled}
			phone={form.draft.phone}
			onPhoneChange={form.setPhone}
			phoneError={form.invalid.phone ? t('contact.phoneInvalid') : null}
			email={form.draft.email}
			onEmailChange={form.setEmail}
			emailError={form.invalid.email ? t('contact.emailInvalid') : null}
			card={profile?.offerContactCard ?? { name: '' }}
			onSave={form.save}
			isSaving={form.isSaving}
			error={form.hasFailed ? (form.error ?? t('contact.saveFailed')) : null}
			saved={form.saved}
			labels={{
				title: t('contact.title'),
				description: t('contact.description'),
				toggle: t('contact.toggle'),
				phone: t('contact.phone'),
				phoneHelp: t('contact.phoneHelp'),
				email: t('contact.email'),
				emailHelp: t('contact.emailHelp'),
				preview: t('contact.preview'),
				photoAlt: t('contact.photoAlt'),
				save: t('contact.save'),
				saved: t('contact.saved'),
			}}
		/>
	)
}
